module.exports = __webpack_public_path__ + "img/colaborador(1).b01e0a54.png";